import { fmtDate, todayISO } from "@/lib/format";

export const STATE_STYLE = {
  presente: ["Presente", "bg-[#a2ca6b]/20 text-[#2f5212]", "#a2ca6b"],
  assente: ["Assente", "bg-slate-600 text-white", "#475569"],
  permesso: ["Permesso", "bg-amber-100 text-amber-800", "#f59e0b"],
  malattia: ["Malattia", "bg-red-100 text-red-700", "#ef4444"],
  altro: ["Altro", "bg-violet-100 text-violet-700", "#8b5cf6"],
  non_lavorativo: ["Riposo", "bg-slate-100 text-slate-400", "#e2e8f0"],
  ferie: ["Ferie", "bg-sky-100 text-sky-800", "#38bdf8", true],
  da_rilevare: ["—", "border border-dashed border-slate-200 text-slate-300", "#fff", true],
  non_rilevato: ["—", "bg-slate-50 text-slate-300", "#fff", true],
};

const fmtH = (h) => `${Math.floor(h)}h${String(Math.round((h % 1) * 60)).padStart(2, "0")}`;

export const mondayOf = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return d.toISOString().slice(0, 10);
};

export const addDays = (iso, n) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

function Cell({ c, compact, testid, onClick }) {
  const [label, cls] = STATE_STYLE[c.state] || STATE_STYLE.da_rilevare;
  const ot = (c.overtime || []).filter((o) => o.status !== "rifiutato");
  const click = onClick && c.state === "presente";
  return (
    <td className="p-1" data-testid={testid}>
      <div className={`rounded-lg px-2 ${compact ? "py-1.5" : "py-2.5"} ${cls} ${c.date === todayISO() ? "ring-2 ring-[#0f1710]/70" : ""} ${click ? "cursor-pointer transition-transform hover:scale-[1.03]" : ""}`}
        title={click ? "Apri il percorso del giorno" : c.time ? `${label} ${c.time}` : label} onClick={click ? () => onClick(c) : undefined}>
        <p className="text-xs font-semibold leading-tight">{c.partial && !["presente", "assente"].includes(c.state) ? `${label} ${c.time}` : label}{c.hours > 0 && <span className="ml-1 font-mono font-normal" data-testid={`${testid}-net`}>{fmtH(c.hours)}</span>}</p>
        {c.first_in && !compact && c.state === "presente" && <p className="font-mono text-[10px]" data-testid={`${testid}-inout`}>{c.first_in}-{c.last_out || "…"}{c.lunch_hours > 0 && <span className="opacity-70"> · pausa {fmtH(c.lunch_hours)}</span>}</p>}
        {!compact && (
          <p className="mt-0.5 text-[10px] opacity-80">
            {c.jobs ? `${c.jobs} interv.` : "\u00a0"}
            {c.partial && ["presente", "assente"].includes(c.state) && <span className="ml-1 text-amber-700">perm. {c.time}</span>}
            {c.pending.length > 0 && <span className="ml-1 font-bold text-amber-700">· {c.pending.length} in attesa</span>}
          </p>
        )}
        {ot.map((o) => (
          <p key={o.start} className={`mt-0.5 rounded px-1 text-[10px] font-bold ${o.status === "accettato" ? "bg-[#0f1710] text-[#a2ca6b]" : "bg-amber-200 text-amber-900"}`}>
            Str. {o.start}-{o.end}{o.status === "in_attesa" ? " ?" : ""}</p>
        ))}
      </div>
    </td>
  );
}

export function WeekGrid({ data, compact = false, onCellClick }) {
  if (!data) return <p className="p-5 text-sm text-slate-500">Caricamento…</p>;
  if (!data.rows.length) return <p className="p-5 text-sm text-slate-500" data-testid="week-grid-empty">Nessun dipendente.</p>;
  const dates = data.rows[0].days.map((d) => d.date);
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[720px] border-separate border-spacing-0 text-left" data-testid="week-grid">
        <thead>
          <tr>
            <th className="w-44 px-3 py-2 text-xs font-semibold text-slate-500">Dipendente</th>
            {dates.map((d) => (
              <th key={d} className={`px-2 py-2 text-xs font-semibold capitalize ${d === todayISO() ? "text-[#61a229]" : "text-slate-500"}`}>
                {fmtDate(d, { weekday: "short", day: "2-digit", month: "2-digit" })}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r, i) => (
            <tr key={r.technician.id} data-testid={`week-row-${i}`}>
              <td className="px-3 py-1 text-sm font-semibold text-slate-900">{r.technician.name}</td>
              {r.days.map((c, j) => <Cell key={c.date} c={c} compact={compact} testid={`week-cell-${i}-${j}`} onClick={onCellClick && ((cell) => onCellClick(r.technician, cell))} />)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export const Legend = () => (
  <div className="flex flex-wrap gap-3 text-xs text-slate-600" data-testid="attendance-legend">
    {Object.entries(STATE_STYLE).filter(([, s]) => !s[3]).map(([k, [l, , c]]) => (
      <span key={k} className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full" style={{ background: c }} />{l}</span>
    ))}
    <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full bg-[#0f1710]" />Straordinario</span>
  </div>
);
